import clsx from 'clsx';
import {
	GasPump,
	Stethoscope,
	Chart,
	Tower,
	Shop,
	WarningShield,
	StarShield,
	Lock,
} from '../public/icons/tsx';
import Icons from '@/const/icons';

export type BadgeTypes =
	| 'whistleblower'
	| 'commodities'
	| 'securities'
	| 'antitrust'
	| 'health_care'
	| 'commercial'
	| 'data_privacy'
	| 'consumer_protection';

export const useClaimIcons = () => {
	const getIcon = (type: BadgeTypes, className?: string, size?: number) => {
		const formattedType = () => {
			return type?.toLocaleLowerCase().replace(' ', '_');
		};

		const parsedType = formattedType();

		switch (parsedType) {
			case 'whistleblower':
				return (
					<WarningShield
						className={clsx('!text-[#FF0043]', className)}
						size={size}
					/>
				);
			case 'commodities':
				return (
					<GasPump className={clsx('!text-[#A0B245]', className)} size={size} />
				);
			case 'health_care':
				return (
					<Stethoscope
						className={clsx('!text-[#2084E7] !w-4', className)}
						size={size}
					/>
				);
			case 'securities':
				return (
					<Chart className={clsx('!text-[#EB35CE]', className)} size={size} />
				);
			case 'antitrust':
				return (
					<Tower className={clsx('!text-[#40BB71]', className)} size={size} />
				);
			case 'commercial':
				return (
					<Shop className={clsx('!text-[#2D41F5]', className)} size={size} />
				);
			case 'data_privacy':
				return (
					<Lock className={clsx('!text-[#FD9834]', className)} size={size} />
				);
			case 'consumer_protection':
				return (
					<StarShield
						className={clsx('!text-[#8F20EF]', className)}
						size={size}
					/>
				);
			default:
				break;
		}
	};

	const dirIcons = {
		whistleblower: Icons.warningShield,
		commodities: Icons.gasPump,
		health_care: Icons.stethoscope,
		securities: Icons.chartPink,
		antitrust: Icons.tower,
		commercial: Icons.shop,
		consumer_protection: Icons.starShield,
		data_privacy: Icons.lock,
	};

	return {
		getIcon,
		dirIcons,
	};
};
